import { useMemo, useState } from 'react'
import api from '../Api'

export const getLicense = licenseId => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const getLicenseCall = async () => {
    setLoading(true)
    setError(null)

    if (!licenseId) {
      setLoading(false)
      return
    }

    try {
      const res = await api.get(`/licenses/${licenseId}`)
      setData(res.data)
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useMemo(() => {
    getLicenseCall()
  }, [licenseId])

  return { data, loading, error }
}



// WEBPACK FOOTER //
// ./src/lib/apiHooks/LicensesApi.js